import { Route } from "@angular/router";
import { LectureImportComponent } from "./lecture-import.component";
import { LectureCheckRouting } from "./lecture-check/lecture-check-routing";
import { LectureRouting } from "./lecture/lecture-routing";
import { AuthorizationGuardService } from "../../../access/shared/authorization/authorization-guard.service";
import { Permissions } from "../../../access/shared/authorization/permissions";

export const LectureImportRouting: Route = {
    path: 'import',
    component: LectureImportComponent,
    canActivate: [AuthorizationGuardService],
    data: {
      breadcrumb: "Import",
      role: [ Permissions.ROLE_LECTURECAB_IMPORT ]
    },
    children: [
      LectureRouting,
      LectureCheckRouting,
      {path: '', redirectTo: 'lecture', pathMatch: 'full'},
    ]
};
